// @flow

import React from "react";

import Section from "../../components/Section";
import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";
import * as mappers from "../../utils/mappers";
import * as v from "../../utils/validators";
import * as formatters from "../../utils/formatters";
import { errors } from "../../utils/errors";

import {
  COLLATERALS,
  PAYMENT_DATE,
  GUARANTEE_SUPPORT,
  EQUITY_SUPPORT,
  STRUCTURING_SUPPORT,
  FINANCING_PRODUCT
} from "./formFields";
import { mapCollateralsKind } from "./mappers";

import { type DetailsProps } from "../../types/details";

const FurtherInformation = ({ initialValues, handleSubmit, site }: DetailsProps) => {
  const productKind = initialValues[FINANCING_PRODUCT];
  if (productKind === null) {
    return null;
  }

  return (
    <Section title="Module der Finanzierung" reducedMargin numbered>
      <EditableForm
        initialValues={initialValues}
        onSubmit={handleSubmit}
        isLocked={
          site === "bank" || !initialValues[COLLATERALS] || !initialValues[COLLATERALS].length
        }
      >
        <FormRow separator>
          <EditableField
            fieldControlProps={{
              name: PAYMENT_DATE,
              caption: () => "Favorisiertes Auszahlungsdatum"
            }}
            displayValue={mappers.dateMapper}
          />
          <div />
          <div />
        </FormRow>
        <FormRow separator>
          <EditableField
            fieldControlProps={{
              name: GUARANTEE_SUPPORT,
              caption: () => "Unterstützung durch Besicherung"
            }}
            displayValue={mappers.yesNoMapper}
          />
          <EditableField
            fieldControlProps={{
              name: EQUITY_SUPPORT,
              caption: () => "Unterstützung durch Eigenkapitalstärkung"
            }}
            displayValue={mappers.yesNoMapper}
          />
          <EditableField
            fieldControlProps={{
              name: STRUCTURING_SUPPORT,
              caption: () => "Unterstützung durch Strukturierung"
            }}
            displayValue={mappers.yesNoMapper}
          />
        </FormRow>
        {initialValues[COLLATERALS] &&
          initialValues[COLLATERALS].length > 0 &&
          initialValues[COLLATERALS].map(({ kind }, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <FormRow key={`${kind}_${index}`}>
              <EditableField
                fieldControlProps={{
                  name: `collaterals[${index}].kind`,
                  caption: () => "Besicherung"
                }}
                displayValue={mapCollateralsKind}
              />
              <EditableField
                fieldControlProps={{
                  name: `collaterals[${index}].value`,
                  caption: () => "Wertseinschätzung"
                }}
                displayValue={formatters.formatCurrency}
              />
              <EditableField
                fieldControlProps={{
                  name: `collaterals[${index}].description`,
                  caption: () => "Beschreibung",
                  validate: v.combineWithPrefillCheck(
                    errors.requiredField(),
                    v.maxLength(500, errors.maxLengthCharacters(500))
                  )
                }}
                type="textArea"
                inputProps={{
                  placeholder: "Kurze Beschreibung der Werteinschätzung"
                }}
              />
            </FormRow>
          ))}
      </EditableForm>
    </Section>
  );
};

export default FurtherInformation;
